module.exports = __webpack_public_path__ + "static/img/8.9de3c4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting602/images/8.png
// module id = hXaD
// module chunks = 4